import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  /*
    This API endpoint expects the following parameters:
    {
      type,       // The type of bucket to access, can be one of the following: [company, project, user].
      id,         // id of the object, A.K.A, the url in file object.
      projectId   // This is required only when type is 'project'.
    }
  */
  async getS3File (params) {
    try {
      await checkLicenseExpiry();
      let requrl = `/files/type=${params.type}&id=${params.id}&projectId=${params.projectId}`;
      if (params.type !== 'project') {
        requrl = `/files/type=${params.type}&id=${params.id}`;
      }
      const { data } = await req.get(requrl);
      return data;
    } catch (error) {
      console.error(error.message);
      throw error;
    }
  },
};